import React from 'react'
import appConstants from './../../../../constants/appConstants'
import env from './../../../../environments/environment'
import './AboutUsLogoShowcase.component.scss'

const AboutUsLogoShowcase = () => {
  return (
    <section className='about-us-logo-showcase'>
      <div className='about-us-logo-showcase__row'>
        <div className='about-us-logo-showcase__col'>
          <img
            src={appConstants.badges.experience}
            alt='USA Benefits Group logo: red ribbon with "1988" and "2026", gold seal with "38 YEARS", and "GROUP" below.'
          />
        </div>
        <div className='about-us-logo-showcase__col'>
          <img
            src={`https://firebasestorage.googleapis.com/v0/b/${env.integrations.firebase.config.storageBucket}/o/static%2Flogos%2Flogo.usabg-amerilife-plain.md.jpg?alt=media`}
            alt='Logo for USA Benefits Group, featuring text and red and blue stripes. Includes "Health • Life • Senior Insurance."'
          />
        </div>
        <div className='about-us-logo-showcase__col'>
          <img
            src={`https://firebasestorage.googleapis.com/v0/b/${env.integrations.firebase.config.storageBucket}/o/static%2Flogos%2Flogo.bbb.png?alt=media`}
            alt='BBB Accredited Business logo, blue and white, with an A+ rating.'
          />
        </div>
      </div>
    </section>
  )
}

export default AboutUsLogoShowcase
